import { OutboundTripDestinationAddressDto } from 'dtos/outboundTrips'
import * as yup from 'yup'

export const OutboundTripDestinationAddressDtoValidator = yup.object<OutboundTripDestinationAddressDto>({
  addressNickname: yup.string().max(200, 'Address Nickname cannot be more than 200 characters.').required('Address Nickname is required.'),
  address1: yup.string().max(200, 'Address 1 cannot be more than 200 characters.').required('Address 1 is required.'),
  address2: yup.string().max(200, 'Address 2 cannot be more than 200 characters.').nullable(),
  city: yup.string().max(200, 'City cannot be more than 200 characters.').required('City is required.'),
  stateProvince: yup.string().max(200, 'State / Province cannot be more than 200 characters.').required('State / Province is required.'),
  // county: yup.string().max(200, 'County cannot be more than 200 characters.').nullable(),
  postalCode: yup.string().max(200, 'Postal Code cannot be more than 200 characters.').required('Postal Code is required.'),
  country: yup.string().max(200, 'Country cannot be more than 200 characters.').required('Country is required.')
})
